var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e8feab0c-cc93-4a09-a2c3-3c1f2982f2f3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,4H14.82A2.98811,2.98811,0,0,0,9.18,4H5A2.00587,2.00587,0,0,0,3,6V20a2.00591,2.00591,0,0,0,2,2H19a2.00591,2.00591,0,0,0,2-2V6A2.00587,2.00587,0,0,0,19,4ZM12,4a1,1,0,1,1-1,1A1.003,1.003,0,0,1,12,4ZM7,8H17v2H7Zm0,4H17v2H7Zm5,6H7V16h5Zm3.15875,1.48675-1.96757-1.96757.78448-.78094,1.2294,1.24279,3.4276-3.46778.74982.74977Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOrders);
export default __webpack_public_path__ + "static/media/work_orders.c74fbe6e.svg";
export { ForwardRef as ReactComponent };